<script>
    import { fade } from "svelte/transition";
    import { lang } from "../scripts/stores";
    import { location } from "svelte-spa-router";

    export let open = false;
    export let icon = "language";

    $: open ? icon = "close" : icon = "language";
    
    function handleChange() {

        // if($location === "/") {
        //     const { origin } = window.location;
        //     window.location.replace(origin + "/");
        // }

        open = false;
    }
</script>

<style>
    .settings {
        position: fixed;
        top: 3rem;
        right: 0;
        width: 280px;
        max-width: 80%;
        padding: 1rem;
        border-radius: 6px;
        border: 1px solid gray;
        background: #fff;
        z-index: 1000;
    }
    .settings-label {
        font-size: 18px;
        font-weight: 500;
    }
</style>

{#if open}
    <div class="settings" transition:fade={{ duration: 200 }}>

        <label class="label" for="lang-menu">
            <span class="label-text settings-label">Valitse kieli / Select language</span>
        </label>    

        <select class="select select-bordered" id="settings-menu" 
            bind:value={ $lang } on:change={ handleChange }
            style="margin-top: 1rem; margin-bottom: 1rem;"
        >
            <option value="fi">suomi</option>
            <option value="en">english</option>
        </select>
    </div>
{/if}